// extracted by mini-css-extract-plugin
export default {"price-not-loaded":"JPuao","price-not-loaded__icon":"sZW2v","price-not-loaded__description":"llRlR"};